import '../variables.css';
export { default } from './Flight';
export { default as MobileFlight } from '../MobileFlight';
